<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="12">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-button type="primary" icon="el-icon-edit" @click="openPkgInfoForm(0)">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" icon="el-icon-download" @click="exportList()">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" icon="el-icon-delete" @click="removePackageInfo(0)">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form :inline="true" :model="formInline" size="mini" class="smui-form-right">
          <el-form-item label="套餐">
            <el-input v-model="formInline.package_name" placeholder="套餐名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchPackageList()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-tabs v-model="tabActiveName" type="card" @tab-click="handleTabsClick">
      <el-tab-pane v-for="item in source_options" :label="item.label" :name="item.value"></el-tab-pane>
    </el-tabs>

    <div class="space-row"></div>

    <el-row :gutter="10">
      <el-col :span="24">
        
            <el-table
              id="tbGridView"
              ref="getTableInstance"
              :data="tableData"
              :height="tableViewHeight"
              v-loading="loadingTableData"
              @selection-change="handleSelectionChange"
              size="small"
              border
              style="width: 100%">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                prop="package_name"
                label="套餐名称"
                width="200">
              </el-table-column>
              <el-table-column
                prop="operator_type"
                label="运营商类型"
                width="120">
              </el-table-column>
              <el-table-column
                prop="period_usage"
                label="周期流量MB"
                width="150">
              </el-table-column>
              <el-table-column
                prop="period_months"
                label="周期(月)"
                width="100">
              </el-table-column>
              <el-table-column
                prop="is_usage_reset"
                label="是否清零"
                width="100">
              </el-table-column>
              <el-table-column
                prop="source_name"
                label="卡源"
                width="150">
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注">
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="录入时间"
                width="200">
              </el-table-column>
              <el-table-column
                prop="operator"
                label="操作"
                width="260">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="openPkgInfoForm(scope.row.package_id)">编辑</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="removePackageInfo(scope.row.package_id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>

      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px">
        <el-form :model="formNew" :rules="rules" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="卡源" :label-width="formLabelWidth">
            <select v-model="tabActiveName" class="fm-select-control">
                <option v-for="item in source_options" :value="item.value">{{item.label}}</option>
            </select>
          </el-form-item>
          <el-form-item label="套餐名称" :label-width="formLabelWidth" prop="package_name">
            <el-input v-model="formNew.package_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="运营商" :label-width="formLabelWidth" prop="card_type">
              <el-dropdown size="small" type="default" @command="handleSelectOperatorType">
                <el-button type="default">
                  {{formNew.operator_type_text}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in operator_type_options" :command="item">{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          <el-form-item label="是否清零">
            <el-radio-group v-model="formNew.is_usage_reset">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="周期流量" :label-width="formLabelWidth" prop="period_usage">
              <el-input v-model.number="formNew.period_usage" autocomplete="off" class="fm2-input-text-wth">
                <template slot="append">MB</template>
              </el-input>
            </el-form-item>
          <el-form-item label="周期短信" :label-width="formLabelWidth" prop="period_sms">
              <el-input v-model.number="formNew.period_sms" autocomplete="off" class="fm2-input-text-wth">
                <template slot="append">条</template>
              </el-input>
            </el-form-item>
          <el-form-item label="周期" :label-width="formLabelWidth" prop="period_months">
            <el-input v-model.number="formNew.period_months" autocomplete="off" class="fm2-input-text-wth">
              <template slot="append">月</template>
            </el-input>
          </el-form-item>
          <el-form-item label="静默期" :label-width="formLabelWidth" prop="quiet_period">
            <el-input v-model.number="formNew.quiet_period" autocomplete="off" class="fm2-input-text-wth">
              <template slot="append">月</template>
            </el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" v-model="formNew.remark" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="savePkgInfo('formNew')" size="small">确 定</el-button>
        </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'package_manage',
  data() {
    return {
      tabActiveName: "1",
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dailRepwdVisible: false,
      dialogTitle: "新增套餐",
      formInline: {
        source_id: null,
        package_name: '',
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      operator_type_options: [],
      source_options: [],
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        package_id: 0,
        package_name: "",
        operator_type: 0,
        operator_type_text: "请选择",
        is_usage_reset: 1,
        period_usage: null,
        period_sms: null,
        period_months: null,
        quiet_period: null,
        source_id: 0,
        source_text: "请选择",
        remark: "",
      },
      rules: {
        package_name: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        period_usage: [
          { required: true, message: '请输入周期流量', trigger: 'blur' },
          { type: 'number', message: '流量必须为数字值'}
        ],
        period_months: [
          { required: true, message: '请输入周期月份', trigger: 'blur' },
          { type: 'number', message: '月份必须为数字值'}
        ],
        period_sms: [
          { type: 'number', message: '短信必须为数字值'}
        ],
        quiet_period: [
          { type: 'number', message: '静默期必须为数字值'}
        ],
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      selectUserId: 0,
      selectUserName: ''
    }
  },
  methods: {
    handleTabsClick: function(tab, event) {
      this.pagging.current_page = 1;
      this.searchPackageList();
    },
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.searchPackageList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectOperatorType: function(cmd) {
      this.formNew.operator_type_text = cmd.label;
      this.formNew.operator_type = cmd.value;
    },
    loadDictionOptions: function() {
      var multipleIds = "1,2";
      Api.GetDetailMultipleItems({ dict_ids: multipleIds }).then(res => {
        if(res && res.code === 200) {
          if(res.data) {
            res.data.forEach(element => {
              if(element.dict_id === 1) {
                this.operator_type_options = element.options;
              } else if(element.dict_id === 2) {
                //this.card_type_options = element.options;
              }
            });
          }
        }
      });
    },
    loadCardSourceOptions: function() {
      this.source_options = [];
      Api.SourceOptions({}).then(res => {
        if(res && res.code === 200) {
          if(res.data) {
            res.data.forEach(element => {
              this.source_options.push({
                value: element.source_id,
                label: element.source_name
              });
            });
            this.tabActiveName = res.data[0].source_id;
            this.formNew.source_id = res.data[0].source_id;
          }
        }
      });
    },
    refreshPageList: function() {
      this.searchPackageList();
    },
    resetFormPkg: function() {
      this.formNew = {
        package_id: 0,
        package_name: "",
        operator_type: 0,
        operator_type_text: "请选择",
        is_usage_reset: 1,
        period_usage: null,
        period_sms: null,
        period_months: null,
        quiet_period: null,
        source_id: 0,
        source_text: "请选择",
        remark: "",
      };
    },
    searchPackageList: function() {
      this.loadingTableData = true;
      this.tableData = [];

      this.formInline.source_id = parseInt(this.tabActiveName);
      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.PackageInfoList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          // let startNum = (this.pagging.current_page - 1) * this.pagging.pager_size;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    exportList: function() {
      var argdata = {
        Name: this.formInline.name,
        containChildren: true,
        HoldID: this.selectHoldId
      };
      Api.Hold_ExportList(argdata).then(res => {
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(res.msg);
          }
          if(res.data) {
            var hostStr = window.location.host;
            var my_request = hostStr.indexOf('gps881.com') > -1 ?
                `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
            window.open(my_request);
          } else {
            this.$message.error('无数据导出！');
          }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleSelectCardType: function(cmd) {
      this.formNew.card_type_text = cmd.label;
      this.formNew.card_type = parseInt(cmd.value);
    },
    openPkgInfoForm: function(id) {
      this.resetFormPkg();
      this.formNew.package_id = id;
      this.dialogFormVisible = true;
      if(id > 0) {
        this.dialogTitle = "修改套餐";
        Api.PackageDetail({ package_id: id }).then(res => {
          if(res && res.code === 200 && res.data) {
            this.formNew.package_name = res.data.package_name;
            this.formNew.operator_type = res.data.operator_type;
            this.formNew.operator_type_text = res.data.operator_type && res.data.operator_type > 0 ? this.operator_type_options.find(x => x.value == res.data.operator_type).label : "";
            this.formNew.period_usage = res.data.period_usage;
            this.formNew.period_sms = res.data.period_sms;
            this.formNew.period_months = res.data.period_months;
            this.formNew.source_id = res.data.source_id;
            this.formNew.source_text = res.data.source_id && res.data.source_id > 0 ? this.source_options.find(x => x.value == res.data.source_id).label : "";
            this.formNew.remark = res.data.remark;
          } else {
            console.log(`获取sim套餐没返回数据${res ? res.msg : ''}`);
            this.$message.error(`出错了！${res ? res.msg : ''}`);
          }
        });
      } else {
        this.dialogTitle = "新增套餐";
      }
    },
    savePkgInfo: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formNew.source_id = parseInt(this.tabActiveName);
          Api.AddPackageInfo(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormPkg();
              this.dialogFormVisible = false;
              this.searchPackageList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removePackageInfo: function(id) {
      this.$confirm('此操作将删除该套餐, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        var masters = [];
        if(id == 0) {
          if(this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(s => {
              masters.push(s.hold_id);
            });
          } else {
            this.$message({
                message: '请选择套餐',
                type: 'warning'
            });
            return;
          }
        } else {
          masters.push(id);
        }
         var argdata = {
            package_ids: masters
          };
          Api.RemovePackageInfo(argdata).then(res => {
            if(!res)
              return;

            if(res.code === 200) {
                this.$message({
                    message: '已删除！',
                    type: 'success'
                });
                this.searchPackageList();
            } else {
                this.$message({
                    message: '删除失败！' + res.msg,
                    type: 'warning'
                });
            }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 300;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
      }
    });

    this.loadDictionOptions();
    this.loadCardSourceOptions();
    this.searchPackageList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
.space-row {
  width: 100%;
  height: 15px;
}
</style>